var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.96,
    height: 32.96,
    viewBox: "0 0 32.96 32.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(-674.426 -731.605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-checkmark-circle",
    "data-name": "Icon ionic-ios-checkmark-circle",
    d: "M19.855,3.375a16.48,16.48,0,1,0,16.48,16.48A16.477,16.477,0,0,0,19.855,3.375ZM28.293,15.3,17.7,25.94h-.008a1.431,1.431,0,0,1-.919.436,1.387,1.387,0,0,1-.927-.452l-4.437-4.437a.316.316,0,0,1,0-.452l1.41-1.41a.306.306,0,0,1,.444,0l3.518,3.518,9.666-9.737a.313.313,0,0,1,.222-.1h0a.288.288,0,0,1,.222.1l1.387,1.434A.312.312,0,0,1,28.293,15.3Z",
    transform: "translate(671.051 728.23)",
    fill: "#7ed321"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-checkmark",
    "data-name": "Icon ionic-ios-checkmark",
    d: "M27.406,13.735,26.011,12.3a.3.3,0,0,0-.222-.1h0a.288.288,0,0,0-.222.1L15.9,22.039l-3.518-3.518a.306.306,0,0,0-.444,0l-1.41,1.41a.316.316,0,0,0,0,.452l4.437,4.437a1.4,1.4,0,0,0,.927.452,1.47,1.47,0,0,0,.919-.436h.008L27.414,14.187A.339.339,0,0,0,27.406,13.735Z",
    transform: "translate(671.94 729.346)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.2ab82ddffb6a3b881a9d51709f6116ba.svg";
export { ForwardRef as ReactComponent };